import { render } from "./VerFinanciadores.vue?vue&type=template&id=5ea2198d"
import script from "./VerFinanciadores.vue?vue&type=script&lang=js"
export * from "./VerFinanciadores.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__